import React from 'react';
import { Home, Sparkles, Move, Building2, CalendarClock, Building } from 'lucide-react';

const services = [
  {
    icon: <Home className="w-8 h-8" />,
    title: "Standard Home Cleaning",
    description: "Perfect for regular maintenance. We cover all living areas, kitchens, and bathrooms to keep your home fresh."
  },
  {
    icon: <Sparkles className="w-8 h-8" />,
    title: "Deep Cleaning",
    description: "A thorough, top-to-bottom scrub. Ideal for first-time cleanings or seasonal refreshes."
  },
  {
    icon: <Move className="w-8 h-8" />,
    title: "Move-In / Move-Out",
    description: "Ensure your new home is spotless or get your security deposit back with our comprehensive turnover cleaning."
  },
  {
    icon: <Building2 className="w-8 h-8" />,
    title: "Apartment Cleaning",
    description: "Specialized cleaning for urban living. We understand the unique needs of Jersey City and Hoboken apartments."
  },
  {
    icon: <CalendarClock className="w-8 h-8" />,
    title: "Recurring Cleaning",
    description: "Save more with weekly, bi-weekly, or monthly schedules. Consistency you can count on."
  },
  {
    icon: <Building className="w-8 h-8" />,
    title: "Airbnb / Rental Cleaning",
    description: "Fast, reliable turnovers for your short-term rental. Five-star cleanliness for every guest."
  }
];

const Services: React.FC = () => {
  return (
    <section className="py-24 bg-brand-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-6">
            Professional Cleaning Services
          </h2>
          <p className="text-lg text-brand-navy/70">
            Tailored cleaning solutions for every home. From standard maintenance to deep scrubs, we've got you covered.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-3xl shadow-premium hover:shadow-premium-hover transition-all duration-300 group border border-gray-100"
            >
              <div className="w-16 h-16 bg-brand-blue/5 rounded-2xl flex items-center justify-center text-brand-blue mb-6 group-hover:bg-brand-blue group-hover:text-white transition-colors duration-300">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-4">{service.title}</h3>
              <p className="text-brand-navy/60 leading-relaxed mb-6">
                {service.description}
              </p>
              <a 
                href="#" 
                className="text-brand-blue font-bold text-sm flex items-center hover:underline"
              >
                Learn More
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
